import axios from 'axios';
import authHeader from './auth-header';
import IColorMetaobject from '../types/colorMetaobject.type';
const API_URL = process.env.REACT_APP_API_ROOT+ '/api/shopify/';

class ShopifyService {
  upsertMetaobject(payload:string) {
    console.log('[upsertMetaobject]');
    let data = {"payload":payload};
    console.log(data);
    return axios.post(API_URL + 'metaobject/single',data, { headers: authHeader(true) });
  }
  upsertMetaobjectInBulk(payload:IColorMetaobject[]) {
    console.log('[upsertMetaobjectInBulk]');
    let data = {"payload":payload};
    console.log(data);
    return axios.post(API_URL + 'metaobject/bulk',data, { headers: authHeader(true) });
  }
}

export default new ShopifyService();
